import React from "react";
import {updateStore} from "./update.store";
import {linksStore} from "./links.store";
import {componentStore} from "./component.store";
import {settingDownloadStore} from "./setting.download.store";
import {patchNotesStore} from "./patch.notes.store";
import {socketStore} from "./web.socket.store";
import { importStore } from "./import.store";
import { secureStore } from "./secure.store";

const storesContext = React.createContext({
    updateStore,
    linksStore,
    settingDownloadStore,
    componentStore,
    patchNotesStore,
    socketStore,
    importStore,
    secureStore,
});

export const useStores = () => React.useContext(storesContext);